import type { SVGProps } from "react"

// The underlying path from Figma lives in an 18x18 coordinate system.
// We render it inside a 24x24 viewBox with a 3-unit inset on each side so
// the visual weight matches lucide-react icons (which also use 24x24) when
// placed alongside them at the same Tailwind size class.
export function ArchiveFilledIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g transform="translate(3 3)">
        <path
          d="M0 1.5C0 0.671573 0.671573 0 1.5 0H16.5C17.3284 0 18 0.671573 18 1.5V3C18 3.82843 17.3284 4.5 16.5 4.5H1.5C0.671573 4.5 0 3.82843 0 3V1.5ZM1 6H17V14.25C17 16.3211 15.3211 18 13.25 18H4.75C2.67893 18 1 16.3211 1 14.25V6ZM7.25 8C6.83579 8 6.5 8.33579 6.5 8.75C6.5 9.16421 6.83579 9.5 7.25 9.5H10.75C11.1642 9.5 11.5 9.16421 11.5 8.75C11.5 8.33579 11.1642 8 10.75 8H7.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
